  <template>
  <div class="row">
    <div class="col-12">
      <div class="">
        <div class="">
          <document-editor :editor-disabled="editorDisabled" :value="notes" @input="getDataFromEditor" />
        </div>
      </div>
      <div v-if="isAuditor() && (status === 'InProgress' || status === 'Accepted')" class="card-footer">
        <div class="form-group m-b-0 text-right">
          <div class="button-group">
            <button :disabled="!saveShow" class="btn waves-effect waves-light btn-success" @click="save">
              <span v-if="saveShow">Save</span>
              <span v-if="!saveShow"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
            </button>
            <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentEditor from '../common/DocumentEditor.vue';
import { mapGetters } from 'vuex';
import EventBus from '../../../event-bus';

export default {
  name: 'Notes',
  components: { DocumentEditor },
  props: ['auditId', 'auditType', 'auditor', 'status', 'auditorNotes'],
  data() {
    return {
      editorDisabled: null,
      notes: null,
      cluster: null,
      saveShow: true,
      auditors: []

    };
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup'])
  },
  beforeMount() {
    this.notes = this.auditorNotes;
  },
  methods: {
    async save() {
      this.saveShow = false;
      if (!this.notes) {
        this.$toastr.e('Please add some Notes.', 'Failed!!!');
        this.saveShow = true;
        return;
      }
      try {
        const noteObject = {};
        noteObject.notes = this.notes;
        await this.$api.patch(`/audits/${this.auditId}/auditor_notes`, noteObject);
        this.$toastr.s('Notes updated successfully.', 'Updated!!!');
        await this.$parent.getAuditById(this.auditId);
        this.saveShow = true;
      } catch (e) {
        this.$showError(e);
        this.saveShow = true;
      }
    },
    getDataFromEditor(event) {
      this.notes = event;
    },
    reset() {
      this.notes = '';
    },
    isAuditor() {
      return (this.activeGroup && (this.auditor === this.activeGroup.anonymous_account));
    }
  }
}
</script>

<style scoped>
</style>
